<script lang="ts">
	import SupportedLanguages from '../SupportedLanguages.svelte'
	import { SupportedLanguage } from '@semanticedge/persistence-service-noheaders-client/src'

	interface Props {
		row: Record<string, string>
		key: string
	}

	let { row, key }: Props = $props()

	const supporteds = $derived(row[key] as unknown as SupportedLanguage[])
</script>

<SupportedLanguages supportedLanguages={supporteds} />

<style>
	:global(.languages-container) {
		display: flex;
		align-items: center;
	}
	:global(.languages-container span) {
		border-radius: 4px;
		overflow: hidden;
	}
</style>
